import { Me } from 'old/types'
import { getUserId, updateUserId, useMutationHandler, useQueryHandler } from 'old/utils'

//useMe:
export const useMe = () => useQueryHandler<Me>({
    query: `
        query getMyInfo {
            getMyInfo {

                id
                email
                firstName
                lastName

                image {
                    id
                    path
                }
                
                locale

            }
        }
    `,
    cacheKey: ['me', getUserId()],
    onSuccess: json => {
        const info = json.data.getMyInfo
        updateUserId(info?.id ?? null)
        return info
    }
})

//update:
export const useProfileUpdate = (me: Me) => useMutationHandler({
    query: `
        mutation updateMe (
            $request: UpdateMeRequest!
        ) {
            updateMe(
                request: $request
            ){
                email
            }
        }
    `,
    variables: {
        request: {
            firstName: me.firstName,
            lastName: me.lastName,
            locale: me.locale
        }
    },
    onSuccess: json => json.data.updateMe.email === me.email
})
